export default "__VITE_ASSET__BTwFGkYK__"